import React from 'react';
import { motion } from "framer-motion";
import SynthwaveHeading from "./Synthwave/Synthwave";
import DragandDrop from "./ui/DragandDrop";
import { useAuth } from '../Context/AuthContext';

export default function Hero({ onLoginClick }) {
  const { user } = useAuth();

  return (
    <section id="home" className="relative w-full h-screen overflow-hidden">
      {/* Background video */}
      <video
        src="/hero_bg.mp4"
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Top heading */}
      <div className="absolute top-10 w-full text-center z-10">
        <motion.h1
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          className="retro-text text-6xl md:text-8xl font-bold uppercase tracking-widest"
        >
          <SynthwaveHeading mainText="Upscale" subText="videos" />
        </motion.h1>
      </div>

      {/* drop region */}
      <div className="absolute bottom-1/3 w-full flex justify-center z-10 px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.8, ease: "easeOut" }}
          className="w-full max-w-3xl"
        >
          {user ? (
            <DragandDrop />
          ) : (
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              className="text-center"
            >
              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={onLoginClick}
                className="inline-block cursor-pointer bg-gradient-to-r from-fuchsia-500/20 to-purple-600/20 backdrop-blur-md border-2 border-fuchsia-500/40 rounded-2xl p-8 hover:border-fuchsia-500/70 hover:shadow-[0_0_30px_rgba(255,0,255,0.5)] transition-all"
              >
                <p className="text-white text-2xl font-bold mb-2 hover:text-fuchsia-400 transition-colors duration-300">
                  Please login to upload a file
                </p>
                <p className="text-gray-400 text-sm">
                  Click here to sign in
                </p>
              </motion.div>
            </motion.div>
          )}
        </motion.div>
      </div>

      {/* Bottom tagline */}
      <div className="absolute bottom-20 w-full text-center z-10 px-4">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.2, duration: 0.8, ease: "easeOut" }}
          className="retro-text mt-4 text-xl md:text-2xl text-white/80"
        >
          <SynthwaveHeading
            mainText=""
            subText="Give your audience the quality they deserve"
          />
        </motion.h2>
      </div>
    </section>
  );
}
